import { NgClass } from '@angular/common';
import { Component, OnDestroy } from '@angular/core';
import { ViewTeamComponent } from 'components/admin/team/view-team.component';
import { CredentialType } from 'enums/CredentialType';
import { HubAction } from 'enums/HubAction';
import { MessageType } from 'enums/MessageType';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { Subscription } from 'rxjs';
import { CredentialRequired } from 'services/credential.service';
import { ComponentUrl, NavigationService } from 'services/navigation.service';
import { NotificationService } from 'services/notification.service';
import { PushService } from 'services/push.service';
import { UserService } from 'services/user.service';

@Component({
	selector: 'list-team',
	templateUrl: './list-team.component.html',
	imports: [Layout, ListView, NgClass, TranslatePipe]
})
@ComponentUrl('list-team')
@CredentialRequired(CredentialType.TeamsAccessFull)
export class ListTeamComponent implements OnDestroy {

	onTeamChanges: Subscription;
	teams: TeamModel[] = [];
	highlightedTeamId?: string;
	activeTeamView?: ViewTeamComponent;

	constructor(private readonly navigation: NavigationService,
		private readonly pushService: PushService,
		private readonly userService: UserService,
		private readonly notification: NotificationService) {

		this.updateTeamsList();

		this.onTeamChanges = this.pushService.onChanges<{ teamId: string }>(MessageType.TeamChanges).subscribe(async message => {
			if (message.data?.teamId) {
				if (message.action == HubAction.Delete && this.highlightedTeamId == message.data?.teamId) {
					this.highlightedTeamId = undefined;
					if (this.activeTeamView) this.navigation.closeView(this.activeTeamView);
				}
				this.updateTeamsList().then(() => {
					const highlightedTeam = this.teams.find(team => team.id == this.highlightedTeamId);
					if (this.highlightedTeamId === message.data?.teamId && highlightedTeam && this.activeTeamView) this.activeTeamView.teamId = highlightedTeam.id;
				});
			}
		});
	}

	updateTeamsList() {
		return this.userService.getAllActiveTeams().then(teams => {
			this.teams = teams;
		});
	}

	displayTeam(team: TeamModel) {
		this.highlightedTeamId = team.id;
		this.navigation.openRelativeView(this, 'view-Team', ViewTeamComponent).then(view => {
			this.activeTeamView = view;
			view.teamId = this.highlightedTeamId;
		});
	}

	createTeam() {
		this.highlightedTeamId = undefined;
		this.navigation.openRelativeView(this, 'view-Team', ViewTeamComponent).then(view => {
			this.activeTeamView = view;
			view.teamId = this.highlightedTeamId;
		});
	}

	canDeleteTeam(team: TeamModel) {
		return team.userTeams.length === 0;
	}

	deleteTeam(team: TeamModel) {
		if (this.canDeleteTeam(team))
			this.notification.confirm('team.prompt-for-delete', { 'team.name': team.name }).subscribe(result => {
				if (result)
					this.userService.deleteTeam(team);
			});
	}

	ngOnDestroy() {
		this.onTeamChanges.unsubscribe();
	}
}
